module.exports = __webpack_public_path__ + "img/carousel-img-4@2x.ae2d13a2.jpg";